/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_ConsultingInputs */

const en_mk_foot_consulting = /** @type {(inputs: Mk_Foot_ConsultingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulting`)
};

const id_mk_foot_consulting = /** @type {(inputs: Mk_Foot_ConsultingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konsultasi`)
};

/**
* | output |
* | --- |
* | "Consulting" |
*
* @param {Mk_Foot_ConsultingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_consulting = /** @type {((inputs?: Mk_Foot_ConsultingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_ConsultingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_consulting(inputs)
	return en_mk_foot_consulting(inputs)
});